import { TenantStore } from './tenant.store';
import { RateStore } from './rate.store';
import { makeAutoObservable } from 'mobx';

export class RootStore {
  tenantStore: TenantStore;
  rateStore: RateStore;

  constructor() {
    makeAutoObservable(this);
    this.tenantStore = new TenantStore(this);
    this.rateStore = new RateStore(this);
  }
}
